import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivityParams } from 'src/models/activity.interface';

@Pipe({
  name: 'descriptionArrayPipe'
})
export class DescriptionArrayPipePipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: string[] | string[][] | undefined): SafeHtml {
    if (!value || value.length === 0) {
      return this.sanitizer.bypassSecurityTrustHtml('Sin descripción');
    }
    let htmlString = '';
    if (Array.isArray(value[0])) {
      htmlString = `<ul class="list-disc pl-5 m-0">` + (value as string[][])[0].map(item => `<li>${item}</li>`).join('') + `</ul>`;
    } else {
      htmlString = `<ul class="list-disc pl-5 m-0">` + (value as string[]).map(item => `<li>${item}</li>`).join('') + `</ul>`;
    }
    return this.sanitizer.bypassSecurityTrustHtml(htmlString);
  }

  // transform(value: string[] | string[][] | ActivityParams[] | undefined): SafeHtml {
  //   if (!value || value.length === 0) {
  //     return this.sanitizer.bypassSecurityTrustHtml('Sin descripción');
  //   }

  //   let htmlString = '<ul style="margin: 0; padding-left: 20px;">';

  //   if (Array.isArray(value) && typeof value[0] === 'string') {
  //     htmlString += (value as string[]).map(item => `<li>${item}</li>`).join('');
  //   } else if (Array.isArray(value) && Array.isArray(value[0])) {
  //     htmlString += (value as string[][])[0].map(item => `<li>${item}</li>`).join('');
  //   } else if (Array.isArray(value) && typeof value[0] === 'object') {
  //     (value as ActivityParams[]).forEach(event => {
  //       if (event.descriptionAsArray && event.descriptionAsArray.length > 0) {
  //         event.descriptionAsArray.forEach(item => {
  //           htmlString += `<li>${item}</li>`;
  //         });
  //       }
  //     });
  //   }

  //   htmlString += '</ul>';
  //   return this.sanitizer.bypassSecurityTrustHtml(htmlString);
  // }
}




